import { Option } from '../../../../../../../../general-types';

export const scoreOptions: Option[] = [{ label: 'Daily score', value: 'DAILY_SCORE' }];
